export default "__VITE_ASSET__DB3bbYNN__"